const configApp = {
  academyDomain: 'https://academia.test.vidroop.com',
  apiKeyTinyMce: 'nmmuxa1oi0rlug1hougubvrgge2hhd73ju9jq5thrlvy62gi',
  apiUrl: 'https://api.test.vidroop.com',
  apiVersion: 'v1',
  appDomain: 'https://academia.test.vidroop.com',
  authCallbackUrl: 'https://academia.test.vidroop.com/login',
  authClientId: 'IE9t0V2VwMDW6oJRvrYvaQYFvMhDraIu',
  authDomain: 'dev-aws-vidroop.eu.auth0.com',
  classroomDomain: 'https://aula.test.vidroop.com/login',
  marketPlaceDomain: 'https://tienda.test.vidroop.com/academia',
  pdfGeneratorDomain: 'https://pdfgenerator.test.vidroop.com/v1/invoice',
  portalDomain: 'https://portal.test.vidroop.com',
  stripePublicKey: 'pk_test_51IsF0cCA8lC7iDvSEsoLJHabyVI0yhFHG0pAgZkjv25ILQujdmFcGGO0jAoZiXeR35kWINTwcH0idrci5oYmFtYb00NIEswIbf',
  universityDomain: 'https://aula.test.vidroop.com/login/42497047-90ac-4937-ad69-5438d8464ac7',
  vidroopAcademyId: '42497047-90ac-4937-ad69-5438d8464ac7',
  zendeskKey: '21304bac-9691-425d-ac5d-4cef3352f6b4',
  droopEvaluacionHabilitado: true,
  droopInteligenciaArtificialHabilitado: true,
  droopRuletaHabilitado: true
}

export default configApp
